import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import {
  reducerAddItem,
  reducerAddItems,
  reducerDeleteInvoiceDetail,
  reducerUpdateInvoice,
  reducerUpdateInvoiceDetail,
} from "../reducer/reducerPostData";
import {
  invoiceDetailsReducer,
  invoicesReducer,
  reducerGetCategory,
  reducerGetClients,
  reducerGetItems,
  reducerGetProduct,
} from "../reducer/reducerGetData";
import authReducer from "../reducer/authReducer";

const rootReducer = combineReducers({
  item: reducerAddItem,
  clients: reducerGetClients,
  product: reducerGetProduct,
  items: reducerGetItems,
  category: reducerGetCategory,
  itemsAdd: reducerAddItems,
  invoices: invoicesReducer,
  invoiceDetails: invoiceDetailsReducer,
  updateInvoiceDetail: reducerUpdateInvoiceDetail,
  deleteInvoiceDetail: reducerDeleteInvoiceDetail,
  updateInvoice: reducerUpdateInvoice,
  auth: authReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
